import { render, staticRenderFns } from "./fangjian.vue?vue&type=template&id=17b093c6&scoped=true&"
import script from "./fangjian.vue?vue&type=script&lang=js&"
export * from "./fangjian.vue?vue&type=script&lang=js&"
import style0 from "./fangjian.vue?vue&type=style&index=0&id=17b093c6&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b093c6",
  null
  
)

export default component.exports